import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import { StyledButton } from '@mlb/react-patterns/components/Button/button.style.tsx';

export const POPOVER_HORIZONTAL_BORDER = 1;

const PopoverContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px;

    ${media.xsmax`
        width: ${({ theme }) => `calc(100vw - ${parseFloat(theme.pageTemplate.paddingLeftRight.xs) * 2}px - ${POPOVER_HORIZONTAL_BORDER * 2}px)`};
    `}

    ${StyledButton} {
        padding-right: 14px;

        svg {
            width: 35px;
        }
    }
`;

export default PopoverContent;